import { RenderWhen } from "../../../../../components";
import { Title } from "../../../../../components/dynamicanalysis";
import { RLcsAnalysisResponseData } from "../hooks/useRlcsAnalysisStatus";
import AnalyzingLoader from "./AnalyzingLoader";

export const QUOTA_EXCEEDED_MSG = "Quota exceeded";

type Props = {
  status: RLcsAnalysisResponseData;
};

const HistoryTitle = ({ status }: Props) => {
  const { automated, interactive } = status ?? {};
  const count = [automated.analyzing, interactive.analyzing].filter(
    Boolean
  ).length;
  return (
    <Title headingLevel="h2" title="History of Dynamic Analysis Results">
      <RenderWhen condition={Boolean(count)}>
        <AnalyzingLoader text={`Analyzing ${count > 1 ? "(2)" : ""}`} />
      </RenderWhen>
    </Title>
  );
};

export default HistoryTitle;
